import styled from 'styled-components';
import { rgba } from 'polished';

import { c211A3C, cEA135E } from '#/colors';

export const Card = styled.div`
  padding: 14px 16px;
  border-radius: 7px;
  background-color: ${c211A3C};
  width: 100%;
`;

export const CardTitle = styled.h2`
  margin: 0;
  margin-bottom: 18px;
  font-size: 16px;
  opacity: 0.7;
`;

export const CardDescription = styled.p`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
`;

export const Container = styled.div`
  padding: 24px;
`;

export const Error = styled.div`
  font-size: 12px;
  color: ${rgba(cEA135E, 0.7)};
`;
